import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { SvgLineIntersectionSplit, SecondaryBtn } from '@tmapy/style-guide';
import { actionActivateIntersectionSplitLineTool, actionDeactivateTools } from '../actions';
export const IntersectionSplitLineToolBtn = ({ isActive, dispatch, children, }) => {
    const handleClick = useCallback(() => {
        if (isActive) {
            dispatch(actionDeactivateTools());
        }
        else {
            dispatch(actionActivateIntersectionSplitLineTool());
        }
    }, [dispatch, isActive]);
    return (_jsx(SecondaryBtn, { icon: { element: _jsx(SvgLineIntersectionSplit, {}) }, isActive: isActive, tooltip: children, onClick: handleClick }));
};
//# sourceMappingURL=IntersectionSplitLineToolBtn.js.map